'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';

/**
 * Client component that keeps `<html lang>` in sync with the
 * active locale. Must be rendered inside a NextIntlClientProvider.
 */
export function HtmlLangSync() {
  const locale = useLocale();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
